export default {
  title: 'Kênh Marketing SMS',

  // Form related
  form: {
    phoneCode: 'Mã Điện Thoại',
    phoneCodePlaceholder: 'Vui lòng nhập mã điện thoại',
    channelName: 'Tên Kênh',
    channelNamePlaceholder: 'Vui lòng nhập tên kênh',
    country: 'Quốc Gia',
    countryPlaceholder: 'Vui lòng chọn quốc gia',
    status: 'Trạng Thái',
    statusPlaceholder: 'Vui lòng chọn trạng thái',
    currency: 'Tiền Tệ',
    currencyPlaceholder: 'Vui lòng chọn tiền tệ',
    cost: 'Giá',
    costPlaceholder: 'Vui lòng nhập giá',
    remark: 'Ghi Chú',
    remarkPlaceholder: 'Vui lòng nhập ghi chú'
  },

  // Table related
  table: {
    channelName: 'Tên Kênh',
    country: 'Quốc Gia',
    cost: 'Giá',
    currency: 'Tiền Tệ',
    status: 'Trạng Thái',
    remark: 'Ghi Chú',
    actions: 'Thao Tác'
  },

  // Status related
  status: {
    enabled: 'Kích Hoạt',
    disabled: 'Vô Hiệu Hóa'
  },

  // Modal related
  modal: {
    editTitle: 'Chỉnh Sửa Kênh SMS'
  },

  // Validation related
  validation: {
    channelNameRequired: 'Vui lòng nhập tên kênh',
    countryRequired: 'Vui lòng chọn quốc gia',
    phoneCodeRequired: 'Vui lòng nhập mã điện thoại',
    currencyRequired: 'Vui lòng chọn tiền tệ',
    costRequired: 'Vui lòng nhập giá',
    costMin: 'Giá không thể nhỏ hơn 0',
    statusRequired: 'Vui lòng chọn trạng thái'
  },

  // Message related
  message: {
    queryFailed: 'Truy vấn thất bại',
    updateSuccess: 'Cập nhật thành công',
    updateFailed: 'Cập nhật thất bại',
    statusUpdateSuccess: 'Cập nhật trạng thái thành công',
    statusUpdateFailed: 'Cập nhật trạng thái thất bại'
  },

  // Confirm related
  confirm: {
    toggleStatus: 'Bạn có chắc chắn muốn chuyển đổi trạng thái của kênh này không?'
  },

  // Pagination related
  pagination: {
    total: 'Tổng cộng {{total}} bản ghi'
  }
};
